import React from "react";
import { TextField, Link, Text } from "@shopify/polaris";
export default function PriorityField({ onChange, value, ...rest }) {
  return (
    <TextField
      label="Priority"
      type="number"
      placeholder="No priority"
      min={0}
      clearButton
      onClearButtonClick={() => onChange(0)}
      helpText={
        <Text variant="bodyMd" as="span">Learn more about{" "}
          <Link
            monochrome
            onClick={() =>
              window.Beacon("article", "637c9f29ceb836124fde328b", {
                type: "modal",
              })
            }
          >
            priority and ordering
          </Link>.</Text>
      }
      {...rest}
      onChange={(value) => onChange(parseInt(value))}
      value={parseInt(value) === 0 ? "" : value}
    />
  );
}
